import RelationshipMetadata from "../../RelationshipMetadata";

class AdminWorkGroupAdminWorkGroupEmployeeRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "AdminWorkGroupAdminWorkGroupEmployeeRelationshipMetadata";
        this.parentEnterpriseComponent = "AdminWorkGroup";
        this.childEnterpriseComponent = "AdminWorkGroupEmployee";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "WorkGroupUSID";
    }
}

export default AdminWorkGroupAdminWorkGroupEmployeeRelationshipMetadata;